import { createContext, useContext, type ReactNode } from "react";
import type { UserProfile } from "./profileSession";

interface UserProfileContextType {
  user: UserProfile | null;
  isLoading: boolean;
  error: Error | null;
}

const UserProfileContext = createContext<UserProfileContextType | undefined>(
  undefined,
);

interface UserProfileProviderProps extends UserProfileContextType {
  children: ReactNode;
}

export function UserProfileProvider({
  children,
  user,
  isLoading,
  error,
}: UserProfileProviderProps) {
  return (
    <UserProfileContext.Provider value={{ user, isLoading, error }}>
      {children}
    </UserProfileContext.Provider>
  );
}

export function useUserProfile(): UserProfileContextType {
  const context = useContext(UserProfileContext);

  if (context === undefined) {
    throw new Error("useUserProfile must be used within a UserProfileProvider");
  }

  return context;
}
